/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Material_No_StockInputs */

const vi_stock_out_material_no_stock = /** @type {(inputs: Stock_Out_Material_No_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa đủ tồn / chưa nhập kho vật tư này`)
};

/**

* @param {Stock_Out_Material_No_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_material_no_stock = /** @type {((inputs?: Stock_Out_Material_No_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Material_No_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_material_no_stock(inputs)
});